<template>
  <div class="container mx-auto py-8 px-3 lg:px-2 h-full">
    <div class="min-h-[150px] lg:min-h-[250px] flex justify-start items-center">
      <div class="text-white  gap-y-4 md:border-l-4 border-secondary px-5 flex flex-col justify-center md:justify-start">
        <div class="w-full flex justify-center md:justify-start">
          <h1
            class="md:text-5xl font-semibold text-2xl md:text-left text-center border-b-2 border-secondary md:border-b-0 ">
            {{ heading }}
          </h1>
        </div>
        <!-- <p class="md:text-xl text-base md:text-left text-center" >
          {{ description }}
        </p> -->
        <p class="md:text-xl text-base md:text-left text-center">
          {{ desc }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
const description = ref("");
const props = defineProps({
  heading: String,
  desc: String,
});
// watch(() => props.desc,
//   (value) => {
//     if (value) {
//       if (value.length > 250) {
//         description.value = value.slice(0, 250).toString() + "...";
//       } else {
//         description.value = value;
//       };
//     };
//   },
// );
</script>